import styles from './styles.module.scss'

import { Helmet } from 'react-helmet';

import { useState } from 'react';
import { Button, Radio, Checkbox, Row, Col } from 'antd';
import { sendEvent, setGaUserProperties } from '@/utils/ga';

import { ButtonQuestion } from '@/components/button/question';

export const PageMy = () => {

  const [type, setType] = useState<'event'|'user_property'>(window.location.href.includes('type=event') ? 'event' : 'user_property')

  const [receiveAd, setReceiveAd] = useState<'yes'|'no'>('yes');
  const [adTypes, setAdTypes] = useState<string[]>(['apple']);

  const [receive_ad, set_receive_ad] = useState(true);
  const [receive_apple, set_receive_apple] = useState(true);
  const [receive_strawberry, set_receive_strawberry] = useState(false);

  const onReceiveAdvertise = (e: any) => {
    console.log('radio checked', e.target.value);

    const nextReceiveAd = e.target.value;
    setReceiveAd(nextReceiveAd);

    const next_set_receive_ad = nextReceiveAd === 'yes';

    /*
     * 광고 수신 허용
     */
    if (next_set_receive_ad) {
      set_receive_ad(next_set_receive_ad);
    }

    /*
     * 광고 수신 거부
     */
    if (!next_set_receive_ad) {
      set_receive_ad(false);
      setAdTypes([]);

      set_receive_apple(false);
      set_receive_strawberry(false);
    }
  };

  const onAdTypeChange = (checkedValues: any) => {
    console.log('checked = ', checkedValues);

    const nextAdTypes = checkedValues;
    setAdTypes(nextAdTypes);

    const nextReceiveApple = receive_ad && nextAdTypes.includes('apple');
    const nextReceiveStrawberry = receive_ad && nextAdTypes.includes('strawberry');

    set_receive_apple(nextReceiveApple);
    set_receive_strawberry(nextReceiveStrawberry);
  }

  const onSaveClick = (e: any) => {
    const nextProperties = {
      receive_ad,
      receive_ad_apple: receive_apple,
      receive_ad_strawberry: receive_strawberry,
    }

    if (type === 'event') {
      sendEvent('config_ad', nextProperties);
      return
    }

    // 유저 프로퍼티 설정
    setGaUserProperties(nextProperties);

    setTimeout(() => {
      window.location.reload();
    }, 600)
  }

  return (
    <>
      <Helmet>
        <title>마이 페이지</title>
      </Helmet>
      <div className={styles.header}>
        <h2>회원 정보</h2>
      </div>
      <div className={styles.description}>
        <p>광고 설정을 변경할 수 있습니다.</p>
      </div>
      <div className={styles.contents}>
        <div className={styles.rowReceiveAd}>
          <div className={styles.colLeft}>
            <p>광고 수신 동의</p>
          </div>
          <div className={styles.colRight}>
            <Radio.Group onChange={onReceiveAdvertise} value={receiveAd}>
              <Radio value={'yes'}>동의</Radio>
              <Radio value={'no'}>거부</Radio>
            </Radio.Group>
          </div>
        </div>
        <div className={styles.rowReceiveAdType}>
          <div>
            <p><strong>광고 수신 유형</strong></p>
          </div>
          <div>
            <Checkbox.Group
              style={{ width: '100%' }}
              disabled={receiveAd !== 'yes'}
              value={adTypes}
              onChange={(checkedValues) => onAdTypeChange(checkedValues)}>
              <Row>
                <Col span={8}>
                  <Checkbox value="apple">사과</Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox value="strawberry">딸기</Checkbox>
                </Col>
              </Row>
            </Checkbox.Group>
          </div>
        </div>
        <hr className={styles.divider} />
        <div className={styles.actions}>
          <Button type="primary" size="large" onClick={(e) => onSaveClick(e)}>설정 저장</Button>
          {
            (type === 'event') && (
              <ButtonQuestion
                title="이벤트 코드 살펴보기"
                content={() => {
                  return (
`
gtag('event', 'config_ad', {
  receive_ad: ${receive_ad},
  receive_ad_apple: ${receive_apple},
  receive_ad_strawberry: ${receive_strawberry},
})
`
                  )
                }}
              />
            )
          }
          {
            (type === 'user_property') && (
              <ButtonQuestion
                title="사용자 속성 코드 살펴보기"
                content={() => {
                  return (
`
gtag('set', 'user_properties', {
  receive_ad: ${receive_ad},
  receive_ad_apple: ${receive_apple},
  receive_ad_strawberry: ${receive_strawberry},
})
`
                  )
                }}
              />
            )
          }
          <br />
        </div>
      </div>
    </>
  );
}